import { CallContactEvent } from '../types';

export type NiceEventRecord = Record<string, unknown>;

export function readStringField(event: NiceEventRecord, ...keys: string[]): string | undefined {
  for (const key of keys) {
    const value = event[key];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
      return String(value);
    }
  }
  return undefined;
}

export function parseBooleanField(event: NiceEventRecord, ...keys: string[]): boolean | undefined {
  for (const key of keys) {
    const value = event[key];
    if (value === true || value === 'True' || value === 'true') {
      return true;
    }
    if (value === false || value === 'False' || value === 'false') {
      return false;
    }
  }
  return undefined;
}

export function resolveCallContactId(event: CallContactEvent): string | null {
  return readStringField(event, 'contactId', 'ContactID', 'masterId', 'MasterID') ?? null;
}

export function resolveCallContactStatus(event: CallContactEvent): string {
  return readStringField(event, 'status', 'Status') ?? '';
}

export function resolveCallContactIsInbound(event: CallContactEvent): boolean | undefined {
  return parseBooleanField(event, 'isInbound', 'IsInbound');
}

export function resolveCallContactSkillId(event: CallContactEvent): string | undefined {
  return readStringField(event, 'skillId', 'SkillId', 'skill', 'Skill');
}

export function resolveCallContactAni(event: CallContactEvent): string | undefined {
  return readStringField(event, 'ani', 'ANI', 'fromAddress', 'FromAddress');
}

export function resolveCallContactDnis(event: CallContactEvent): string | undefined {
  return readStringField(event, 'dnis', 'DNIS', 'toAddress', 'ToAddress');
}

export function resolveCallContactLabel(event: CallContactEvent): string | undefined {
  return readStringField(event, 'label', 'Label');
}

export function resolveCallContactStartTime(event: CallContactEvent): Date | string | undefined {
  return readStringField(event, 'startTime', 'StartTime', 'StartTimeUTC');
}

export function resolveCallContactManualAccept(event: CallContactEvent): boolean | undefined {
  return parseBooleanField(event, 'isRequireManualAccept', 'IsRequireManualAccept');
}

export function resolveCallContactFinalState(event: CallContactEvent): boolean | undefined {
  return parseBooleanField(event, 'finalState', 'FinalState');
}

export function resolveAgentLegId(event: NiceEventRecord): string | null {
  return readStringField(event, 'agentLegId', 'AgentLegId', 'legId', 'LegId') ?? null;
}

export function resolveAgentLegStatus(event: NiceEventRecord): string {
  return readStringField(event, 'status', 'Status') ?? '';
}

export function resolveAgentLegFinalState(event: NiceEventRecord): boolean | undefined {
  return parseBooleanField(event, 'finalState', 'FinalState');
}
